import Vue from 'vue'
import Vuex from 'vuex'
import team from './modules/team';
import demands from './modules/demands';
import planning from './modules/planning';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    team,
    demands,
    planning
  }
})
